const React = require('react')
const { Col } = require('reactstrap')

const FooterProductsColumn = () => {
    return (
        <Col className='footer-section'>
            <h5 className='footer-title'>Products</h5>
            <div className='footer-links'>
                <a
                    href='https://agridential.vn/'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <img
                        src='https://res.cloudinary.com/agridential/image/upload/v1600757777/Logo/agdnew_ctihrd-removebg-preview_km4ppl.png'
                        alt='Agridential'
                    />
                    Agridential.vn
                </a>
                <a
                    href='https://covidpass.vn/'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <img
                        src='https://res.cloudinary.com/agridential/image/upload/v1617072333/AGDImage/logo_covid_pass_1_3x_llsuvm.png'
                        alt='Covid Pass'
                    />
                    Covidpass.vn
                </a>
                <a
                    href='https://smartballot.io/'
                    target='_blank'
                    rel='noopener noreferrer'
                >
                    <img
                        src='https://res.cloudinary.com/agridential/image/upload/v1624008907/SmartBallot/Screen_Shot_2021-06-18_at_4.31.17_PM-removebg-preview_1_wkpjg0.png'
                        alt='Smart Ballot'
                    />
                    Smartballot.io
                </a>
            </div>
        </Col>
    )
}

module.exports = { FooterProductsColumn }
